import { ScheduleTimeframe } from '../../../../../shared/sdk/index';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-timeframe-item',
  templateUrl: './timeframe-item.component.html',
  styleUrls: ['./timeframe-item.component.css'],
})
export class TimeframeItemComponent implements OnInit {

  @Input() timeframe: ScheduleTimeframe;
  @Output() onDeleteClick = new EventEmitter();


  constructor() { }

  ngOnInit() {
  }

  deleteClick(event, stf) {
    const eventObj = {
      originalEvent: event,
      stf: stf
    };
    this.onDeleteClick.emit(eventObj);
  }

}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/scheduling/components/timeframe-item/timeframe-item.component.ts